import { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const IMAGE =
  'https://readdy.ai/api/search-image?query=Ultra-realistic%20cinematic%20aerial%20drone%20photograph%20of%20a%20dramatic%20Puerto%20Rican%20coastline%20at%20golden%20hour%2C%20emerald%20turquoise%20Atlantic%20water%20meeting%20pale%20volcanic%20sand%20and%20lush%20tropical%20jungle%20cliffs%2C%20warm%20afternoon%20light%2C%20subtle%20wave%20patterns%2C%20contemporary%20editorial%20travel%20magazine%20aesthetic%2C%20muted%20natural%20color%20grading%2C%20minimal%20composition%2C%20soft%20mist&width=2600&height=1600&seq=manifesto-coastline-aerial-01&orientation=landscape';

export default function Manifesto() {
  const rootRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) return;

      gsap.to('.manifesto__img', {
        yPercent: 30,
        ease: 'none',
        scrollTrigger: {
          trigger: rootRef.current,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });
    }, rootRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={rootRef} className="manifesto" id="sanctuary">
      <div className="manifesto__img-wrap">
        <img
          className="manifesto__img"
          src={IMAGE}
          alt="Aerial view of dramatic Puerto Rican coastline at golden hour"
        />
      </div>
      <h2 className="manifesto__title">
        Where the
        <br />
        Atlantic <span className="manifesto__slash">/</span> Rests
      </h2>
    </section>
  );
}